import { render, staticRenderFns } from "./DeleteEmployeetype.vue?vue&type=template&id=393bb52e"
import script from "./DeleteEmployeetype.vue?vue&type=script&lang=js"
export * from "./DeleteEmployeetype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports